import React, { useState, useEffect } from "react";
export { Profiles } from "./Profiles";
export { ProfileSettings } from "./Settings";
import styled from "styled-components";
import { Profiles } from "./Profiles";
import { ProfileSettings } from "./Settings";
import MarkdownHelpModal from "common/MarkdownHelpModal";

const ShowsOnlyFirst = styled.div`
  & > * + * {
    display: none !important;
  }
`;

const getRules = (response) => {
  const lines = response.trim().split("\n");
  const rules = lines.reduce((acc, line) => {
    if (line.startsWith(`rule`)) {
      acc.push(line);
    }
    return acc;
  }, []);
  return rules;
}

const ProfilesAndSettings = ({ help, settingsHelp, typeLabel, ...settings }) => {
  const [rules, setRules] = useState("");

  useEffect(() => {
    ifCl
      .run("show config running all")
      .then((response) => {
        const rules = getRules(response);
        setRules(rules)
      }
      )
      .catch((error) => console.log(error));
  }, []);

  return (
    <>
      <ShowsOnlyFirst>
        {<ProfileSettings typeLabel={typeLabel} {...settings} />}
        {/*or will show*/}
        <Profiles typeLabel={typeLabel} {...settings} rules={rules} />
      </ShowsOnlyFirst>
      {help ? (
        <MarkdownHelpModal
          title={`${typeLabel} profiles`}
          source={help}
        />
      ) : null}
      {settingsHelp ? (
        <MarkdownHelpModal
          title={`${typeLabel} profile settings`}
          source={settingsHelp}
          signal="open-settings-help"
        />
      ) : null}
    </>
  );
};

export default ProfilesAndSettings;
